import { NgModule } from '@angular/core';
import { STATES } from './microsites.states';
import { UIRouterModule } from '@uirouter/angular';
import { GlobalModule } from '../global/global.module';
import { ApiModule } from '../api/api.module';
import { GiftService } from './gift/gift.service';
import { GiftComponent } from './gift/gift.component';

@NgModule({
  declarations: [
    GiftComponent
  ],
  imports: [
    GlobalModule,
    ApiModule,
    UIRouterModule.forChild({ states: STATES })
  ],
  providers: [
    GiftService
  ],
  exports: []
})
export class MicrositesModule {
}


// WEBPACK FOOTER //
// ./src/app/microsites/microsites.module.ts